import React from 'react';

import './style.css'


interface IModalProps {
    icon: string,
    title: string,
    message: React.ReactNode,
    isOpen: boolean,
    onYes: () => void,
    onNo: () => void,
    buttonYesText: string,
}

const ConfirmModal2: React.FC<IModalProps> = ({ icon, title, message, buttonYesText, isOpen = false, onYes, onNo }) => {

    if (!isOpen) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className='center-middle'>
                    <div className="icon-size-3">
                        <img className="responsive-image" src={icon} alt="modal icon" />
                    </div>
                </div>
                <br />
                <div className='center-middle' style={{ color: '#f05a5a', fontSize: '40px', fontWeight: 'bold' }}>
                    {title}
                </div>
                <br />
                <div className='center-middle font-size-17px'>
                    {message}
                </div>
                <br />
                <hr style={{ border: '1px solid lightgray', margin: '0 0 16px 0' }} />
                <div className="center-middle">
                    <button type="button" className='btn-green-3 center-middle' onClick={onYes}>{buttonYesText}</button>
                    &nbsp;  &nbsp;
                    <button type="button" className='btn-white-green-3 center-middle' onClick={onNo}>Cancel</button>
                </div>
            </div>
        </div>
    );

}

export default ConfirmModal2;
